if (!('remove' in Element.prototype)) {
  Element.prototype.remove = function () {
    if (this.parentNode) {
      this.parentNode.removeChild(this);
    }
  };
}

if (!('remove' in NodeList.prototype)) {
  NodeList.prototype.remove = HTMLCollection.prototype.remove = function () {
    for (var i = this.length - 1; i >= 0; i--) {
      if (this[i] && this[i].parentNode) {
        this[i].parentNode.removeChild(this[i]);
      }
    }
  };
}

// Product Titles: Replace straight quotes with curly quotes
const replaceProductTitleQuotes = (productTitles) => {
  const titleQuotePattern = /(\s|^)\'([^\']+)\'(?=\s|$)/g;
  productTitles.forEach(title => {
    title.textContent = title.textContent.replace(titleQuotePattern, "$1\u2018$2\u2019");
  });
}
replaceProductTitleQuotes(document.querySelectorAll('[data-product-title]'));

const callOnLoad = callback => {
  if (document.readyState === 'complete') {
    callback();
  } else {
    window.addEventListener('load', callback);
  }
};

class MiniCart {
  constructor(cartEndpoint) {
    this.cartEndpoint = cartEndpoint ? cartEndpoint : "/cart.js";
    this.minicart = document.querySelector("[data-minicart]");
    this.items = document.querySelector("[data-minicart-items]");
    this.item = "data-minicart-item";
    this.close = "data-minicart-close";
    this.open = "data-minicart-open";
    this.plus = "data-minicart-plus";
    this.minus = "data-minicart-minus";
    this.count = "data-minicart-count";
    this.totalCount = document.querySelectorAll("[data-minicart-totalCount]");
    this.remove = "data-minicart-remove";
    this.subtotal = document.querySelector("[data-minicart-subtotal]");
    this.subtotalPlaceholder = document.querySelector("[data-minicart-subtotal-placeholder]");

    this.timedelay = 0;
    this._delay;
  }

  delayCheck() {
    if (this.timedelay == 10) {
      this.minicart.classList.remove("open");
      this.minicart.classList.add("close");

      enableScrolling();
      this.timedelay = 0;
      clearInterval(this._delay);
    }
    this.timedelay = this.timedelay + 1;
  }

  openCart(target) {
    if (this.minicart && target.hasAttribute(this.open)) {
      this.minicart.classList.add("open");
      this.minicart.classList.remove("close");
    }
  }

  closeCart(target) {
    if (this.minicart && target.hasAttribute(this.close)) {
      this.minicart.classList.remove("open");
      this.minicart.classList.add("close");
      enableScrolling();
      bodyScrollLock.enableBodyScroll(this.minicart);
    }
  }

  updatTotalCount(total) {

    if (total > 0) {
      this.minicart.classList.remove("empty");
      this.minicart.classList.add("not-empty");
    } else {
      this.minicart.classList.remove("not-empty");
      this.minicart.classList.add("empty");
    }

    if (!total) {
      this.totalCount.forEach((tcc) => { tcc.innerHTML = '0'; tcc.style.display = "none"; });

      return false;
    }
    if (this.totalCount) {

      this.totalCount.forEach((tc) => {
        if (tc.classList.contains('no-add-zero')) {

          if (tc.classList.contains('add-parenthesis')) {
            tc.innerHTML = "(" + total + ")"
          } else {
            tc.innerHTML = total
          }

        } else {
          var ttl = total
          if (total <= 9) {
            ttl = '0' + total
          }
          tc.innerHTML = ttl
        }

        tc.style.display = "inline";
      });
    }

    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { count: total || 0 } }));
  }

  updateSubtotal(total) {
    if (!total) {
      total = '0';
    }
    if (this.subtotal) {
      this.subtotal.innerHTML = this.moneyFormat(total);
      this.subtotalPlaceholder.setAttribute("data-amount", total);
    } else {
      this.subtotal.innerHTML = '$0.00';
      this.subtotalPlaceholder.setAttribute("data-amount", 0);
    }
    if (typeof window.affirm !== 'undefined' && typeof window.affirm.ui.refresh !== 'undefined') {
      this.updateAffirmMessage();
      affirm.ui.refresh();
    }
  }

  updateAffirmMessage() {
    let affirmWrappers = document.querySelectorAll('.affirm-wrapper');
    if (affirmWrappers.length > 0) {
      affirmWrappers.forEach(container => {
        container.classList.add('updating');
        setTimeout(() => {
          let trigger = container.querySelector('.affirm-modal-trigger');
          if (trigger) trigger.innerText = 'Read more';
          container.classList.remove('updating');
        }, 1000);
      });
    }
  }

  updateCart(openCart = true) {
    fetch(this.cartEndpoint)
      .then((resp) => resp.json())
      .then((cart) => {
        if (cart) {
          this.updateSubtotal(cart.total_price);
          this.updatTotalCount(cart.item_count);
          let allItems = "";
          for (let item of cart.items) {
            allItems += this.cartItemHTML(item);
          }
          if (this.items) {
            this.items.innerHTML = allItems;
            replaceProductTitleQuotes(this.items.querySelectorAll('[data-product-title]'));
          }
          if (cart.items.length < 1) {
            this.isEmpty();
          } else {
            this.isFilled(openCart);
          }
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  isFilled(openCart = true) {
    if (this.minicart) {
      this.minicart.classList.remove("empty");
      if (openCart) {
        this.minicart.classList.remove("close");
        this.minicart.classList.add("open");

        disableScrolling();
        this.timedelay = 0;
        var that = this;
        this._delay = setInterval(function () {
          that.delayCheck();
        }, 700);
      }
    }
  }

  isEmpty() {
    if (this.minicart) {
      this.minicart.classList.add("empty");
    }
  }

  removeCartItem(target) {
    if (target.hasAttribute(this.remove)) {
      const id =
        this.findAncestor(target, `[${this.item}]`) &&
        this.findAncestor(target, `[${this.item}]`).dataset["minicartItem"];
      if (id) {
        document.getElementById('cart-overlay').classList.remove("hidden");
        this.timedelay = 0;
        clearInterval(this._delay);

        fetch("/cart/change.js", {
          method: "post",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: id,
            quantity: 0,
          }),
        })
          .then((resp) => resp.json())
          .then((cart) => {
            this.updateCart();
            document.getElementById('cart-overlay').classList.add("hidden");
          })
          .catch((error) => {
            console.error(error);
          });
      }
    }
  }

  minusCartItem(target) {
    if (target.hasAttribute(this.minus)) {
      const id =
        this.findAncestor(target, `[${this.item}]`) &&
        this.findAncestor(target, `[${this.item}]`).dataset["minicartItem"];
      const quantityPicker = target.parentNode;
      const countElem = quantityPicker.querySelector(`[${this.count}]`);
      const newQuantity =
        countElem.textContent && parseInt(countElem.textContent) - 1;
      if (id && newQuantity >= 0) {
        document.getElementById('cart-overlay').classList.remove("hidden");
        this.timedelay = 0;
        clearInterval(this._delay);

        fetch("/cart/change.js", {
          method: "post",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: `quantity=${newQuantity}&id=${id}`,
        })
          .then(() => {
            this.updateCart();
            document.getElementById('cart-overlay').classList.add("hidden");
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      }
    }
  }

  plusCartItem(target) {
    if (target.hasAttribute(this.plus)) {
      const id =
        this.findAncestor(target, `[${this.item}]`) &&
        this.findAncestor(target, `[${this.item}]`).dataset["minicartItem"];

      const qty =
        this.findAncestor(target, `[${this.item}]`) &&
        this.findAncestor(target, `[${this.item}]`).dataset["qty"];

      window.item_qty = qty;
      window.item_id = id;

      if (id) {
        document.getElementById('cart-overlay').classList.remove("hidden");
        this.timedelay = 0;
        clearInterval(this._delay);

        fetch("/cart/change.js", {
          method: "post",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: id,
            quantity: parseInt(qty) + 1,
          }),
        })
          .then((resp) => resp.json())
          .then((data) => {
            if (data.status === 422) {
              alert(data.description);
            } else {
              this.updateCart();

              for (let item of data.items) {
                if (item.id == window.item_id && item.quantity == window.item_qty) {
                  alert(window.cartStrings.quantityError.replace('[quantity]', item.quantity));
                }
              }
            }
            document.getElementById('cart-overlay').classList.add("hidden");
          })
          .catch((error) => {
            console.error("Error:", error);
          });
      }
    }
  }

  cartItemHTML(item) {
    function buildProps(item) {
      if (
        !item ||
        !item.properties ||
        Object.keys(item.properties).length === 0
      )
        return "";

      let result = "";
      for (const [key, value] of Object.entries(item.properties)) {
        result += ` wrapper__${value}`;
      }
      return result.trim();
    }

    function buildOptions(item) {
      if (
        !item ||
        !item.options_with_values ||
        item.options_with_values.length === 0
      )
        return "";

      let result = "";
      for (let option of item.options_with_values) {
        if (option.value !== "Default Title") {
          result += `<li>${option.value}</li>`; // ${option.name}:
        }
      }
      return result;
    }

    function getImage(image, size = 300) {
      if (!image) return "";
      const ext = image.match(/\.(?:jpg|gif|png)/g);
      return image.replace(ext[0], `_${size}x` + ext[0]);
    }

    function buildImage(item) {
      if (!item) return "";
      return `<img alt="" class="responsive-image__image lazyload" data-sizes="auto" src="${getImage(
        item.image,
        300
      )}" data-src="${getImage(item.image, 300)}">`;
    }

    let cartItem = miniCartItem;

    if (cartItem) {
      cartItem = cartItem.replace(/{{itemImage}}/g, buildImage(item));
      cartItem = cartItem.replace(/{{itemVariantId}}/g, item.id);
      cartItem = cartItem.replace(/{{itemTitle}}/g, item.product_title.replace('-', '-&#8288;'));
      cartItem = cartItem.replace(/{{itemUrl}}/g, item.url);
      cartItem = cartItem.replace(
        /{{itemComparePrice}}/g,
        item.original_price > item.price
          ? this.moneyFormat(item.original_price)
          : ""
      );
      cartItem = cartItem.replace(
        /{{itemPrice}}/g,
        this.moneyFormat(item.price)
      );
      cartItem = cartItem.replace(/{{itemOptions}}/g, buildOptions(item));
      cartItem = cartItem.replace(/{{itemProps}}/g, buildProps(item));
      cartItem = cartItem.replace(/{{itemQuantity}}/g, item.quantity);
    }
    return cartItem;
  }

  hideOnEscape(e) {
    var keyCode = e.keyCode;
    if (keyCode === 27 && this.minicart) {
      this.minicart.classList.remove("open");
      this.minicart.classList.add("close");
    }
  }

  moneyFormat(amout, customCurrency = "$") {
    if (!amout) return "";
    if (typeof Shopify.formatMoney === "function") {
      const currency = Shopify.money_format.split("{")[0];
      return Shopify.formatMoney(amout, `${currency}{{amount_no_decimals}}`);
    } else {
      const currency = customCurrency;
      return `${currency}${amout / 100}`;
    }
  }

  findAncestor(el, sel) {
    while (
      (el = el.parentElement) &&
      !(el.matches || el.matchesSelector).call(el, sel)
    );
    return el;
  }

}

document.addEventListener("DOMContentLoaded", function (event) {
  const mini_cart = new MiniCart();

  // Assign mini_cart variable to global usage
  window.mini_cart = mini_cart;

  // Init Cart Items
  mini_cart.updateCart(false);

  // Hide MiniCart on Escape keydown
  document.addEventListener("keydown", function (e) {
    mini_cart.hideOnEscape(e);
  });

  document.addEventListener("click", (e) => {
    mini_cart.timedelay = 0;
    clearInterval(mini_cart._delay);
    if (mini_cart.minicart.classList.contains('open')) {
      mini_cart._delay = setInterval(function () {
        mini_cart.delayCheck();
      }, 700);
    }
  });

  window.addEventListener("scroll", (e) => {
    mini_cart.timedelay = 0;
    clearInterval(mini_cart._delay);
    if (mini_cart.minicart.classList.contains('open')) {
      mini_cart._delay = setInterval(function () {
        mini_cart.delayCheck();
      }, 700);
    }
  });

  // MiniCart Events
  document.addEventListener("click", function (e) {
    mini_cart.openCart(e.target);
    mini_cart.removeCartItem(e.target);
    mini_cart.plusCartItem(e.target);
    mini_cart.minusCartItem(e.target);
    mini_cart.closeCart(e.target);
  });
});



function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function getCookie(name) {
  return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" +
    encodeURIComponent(name).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
}

function setCookie(name, value, expiresdays, path, domain, secure) {
  var date = new Date(); date.setTime(date.getTime() + (expiresdays * 24 * 60 * 60 * 1000));
  document.cookie = encodeURIComponent(name) + "=" + escape(value) +
    ((expiresdays) ? "; expires=" + date.toUTCString() : "") +
    ((path) ? "; path=" + path : "") + ((domain) ? "; domain=" + domain : "") + ((secure) ? "; secure" : "");
}

const $body = document.querySelector('body');
let scrollPosition = 0;

function disableScrolling() {
  scrollPosition = window.pageYOffset;
  $body.style.overflow = 'hidden';
  $body.style.position = 'inherit';
  $body.style.top = `-${scrollPosition}px`;
  $body.style.width = '100%';
};

function enableScrolling() {
  $body.style.removeProperty('overflow');
  $body.style.removeProperty('position');
  $body.style.removeProperty('top');
  $body.style.removeProperty('width');
  window.scrollTo(0, scrollPosition);
};


document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
* Shopify Common JS
*
*/
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  // Custom select
  this.countryEl$custom = document.querySelector(''.concat('.customSelect #' + country_domid)) && document.querySelector(''.concat('.customSelect #' + country_domid)).customSelect;
  this.ProvinceEl$custom = document.querySelector(''.concat('.customSelect #' + province_domid)) && document.querySelector(''.concat('.customSelect #' + province_domid)).customSelect;

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    this.ProvinceEl$custom && this.ProvinceEl$custom.empty();
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);

        this.ProvinceEl$custom && this.ProvinceEl$custom.append(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    this.mql = window.matchMedia('(max-width: 989px)');
    this.handleKeyUp = this.onKeyUp.bind(this);
    this.handleFocusOut = this.onFocusOut.bind(this);
    this.handleSummaryClick = this.onSummaryClick.bind(this);
    this.handleCloseButtonClick = this.onCloseButtonClick.bind(this);
    this.handleResize = debounce(this.onResize.bind(this), 100);

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  }

  connectedCallback() {
    this.bindEvents();
  }

  disconnectedCallback() {
    this.unbindEvents();
  }

  bindEvents() {
    this.addEventListener('keyup', this.handleKeyUp);
    this.addEventListener('focusout', this.handleFocuOut);
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.handleSummaryClick));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.handleCloseButtonClick));
    window.addEventListener('resize', this.handleResize);
  }

  unbindEvents() {
    this.removeEventListener('keyup', this.handleKeyUp);
    this.removeEventListener('focusout', this.handleFocuOut);
    this.querySelectorAll('summary').forEach(summary => summary.removeEventListener('click', this.handleSummaryClick));
    this.querySelectorAll('button').forEach(button => button.removeEventListener('click', this.handleCloseButtonClick));
    window.removeEventListener('resize', this.handleResize);
  }

  onResize(e) {
    if (this.isOpen() && !this.mql.matches) {
      this.closeMenuDrawer(e);
    }
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  isOpen() {
    return this.mainDetailsToggle.hasAttribute('open');
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    bodyScrollLock.disableBodyScroll(this);
    document.body.classList.add('menu-drawer-open');

  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });

      document.body.classList.remove('menu-drawer-open');
      bodyScrollLock.enableBodyScroll(this);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add('menu-drawer-open');
    bodyScrollLock.disableBodyScroll(this);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    if (this.querySelector('.overlay')) {
      this.querySelector('.overlay').addEventListener(
        'click',
        this.hide.bind(this)
      );
    }
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
    bodyScrollLock.disableBodyScroll(this);
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
    bodyScrollLock.enableBodyScroll(this);
  }
}
customElements.define('modal-dialog', ModalDialog);


class ModalDialogFooter extends ModalDialog {
  constructor() {
    super();

    this.body = document.body,
      this.html = document.documentElement;
    this.height = Math.max(this.body.scrollHeight, this.body.offsetHeight,
      this.html.clientHeight, this.html.scrollHeight, this.html.offsetHeight);
    this.klaviyoForm = this.querySelector('[class^="klaviyo-form-"]');

    var that = this;

    // if ( (that.height / 4) < window.scrollY ) {
    //   if (!getCookie(that.dataset.cookieName) && !that.hasAttribute('open')) {
    //     that.initFooterPopup(that);
    //   }
    // }

    // window.addEventListener("scroll", (e) => {
    //   that.height = Math.max( that.body.scrollHeight, that.body.offsetHeight, 
    //                    that.html.clientHeight, that.html.scrollHeight, that.html.offsetHeight );

    //   if ( (that.height / 4) < window.scrollY ) {
    //     if (!getCookie(that.dataset.cookieName) && !that.hasAttribute('open')) {
    //       that.initFooterPopup(that);
    //     }
    //   }
    // });
  }

  initFooterPopup(that) {
    if (that.klaviyoForm.innerHTML !== "") {
      that.show(document);
      window.clearTimeout(that.initFooterPopup);
    } else {
      setTimeout(() => {
        that.initFooterPopup(that)
      }, 200)
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
  }

  hide() {
    this.removeAttribute('open');
    setCookie(this.dataset.cookieName, true, this.dataset.cookieExpire);
  }

}
customElements.define('modal-dialog-footer', ModalDialogFooter);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');
    const video_container = this.querySelector('.image-wrapper--main');

    if (button) {
      button.addEventListener('click', () => {
        const modal = document.querySelector(this.getAttribute('data-modal'));
        if (modal) modal.show(button);
      });
    }
    if (video_container) {
      video_container.addEventListener('click', () => {
        const modal = document.querySelector(this.getAttribute('data-modal'));
        if (modal) modal.show(video_container);
      });
    }
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));

    let player, video, progressRange, progressBar, currentTime, duration;
    let speakerIcon, ranges, speaker, volInput, muted, playLeftBtn, playRightBtn, stopBtn, skipButtons;

  }

  setupCustomPlayer() {
    this.player = this.querySelector('.libertine-player');
    if (!this.player) return;

    this.video = this.player.querySelector('.viewer');
    this.progressRange = this.player.querySelector('.progress-range');
    this.progressBar = this.player.querySelector('.progress-bar');
    this.currentTime = this.player.querySelector('.time-elapsed');
    this.duration = this.player.querySelector('.time-duration');

    this.playLeftBtn = this.player.querySelector('.left-controls .play');
    this.playRightBtn = this.player.querySelector('.right-controls .play');
    this.stopBtn = this.player.querySelector('.stop');

    this.skipButtons = this.player.querySelectorAll('[data-skip]');

    this.speakerIcon = this.player.querySelector('.speaker_icon');
    this.ranges = this.player.querySelectorAll('.player_slider');
    /* MUTE button */
    this.speaker = this.player.querySelector('.speaker');
    this.volInput = this.player.querySelector('input[name="volume"]');
    this.muted = false;

    this.video.addEventListener('ended', this.endedVideo.bind(this));
    this.video.addEventListener('timeupdate', this.updateProgress.bind(this));
    this.video.addEventListener('canplay', this.updateProgress.bind(this));
    this.progressRange.addEventListener('click', this.setProgress.bind(this));

    /*functions linked to elements*/
    // play, pause, stop
    this.video.addEventListener('click', this.togglePlay.bind(this));
    this.video.addEventListener('keydown', (event) => event.keyCode === 32 && this.togglePlay.bind(this));
    this.playLeftBtn.addEventListener('click', this.togglePlay.bind(this));
    this.playRightBtn.addEventListener('click', this.togglePlay.bind(this));
    this.stopBtn.addEventListener('click', this.stopVideo.bind(this));
    // skip forward or backward
    var that = this;
    this.skipButtons.forEach(button => button.addEventListener('click', this.skip.bind(this, button, that.video)));
    // volume
    this.ranges.forEach(range => range.addEventListener('change', this.handleRangeUpdate.bind(this)));
    this.ranges.forEach(range => range.addEventListener('mousemove', this.handleRangeUpdate.bind(this)));
    this.speaker.addEventListener('click', this.mute.bind(this));

    // progress bar controls
    let mouseDown = false;
    this.progressRange.addEventListener('click', this.scrub.bind(this));
    this.progressRange.addEventListener('mousemove', (event) => mouseDown && scrub(event));
    this.progressRange.addEventListener('mousedown', () => mouseDown = true);
    this.progressRange.addEventListener('mouseup', () => mouseDown = false);

    //fullscreen mode 
    const screen_size = this.player.querySelector('.screenSize');
    const controls = this.player.querySelector('.player_controls');
    const screenSize_icon = this.player.querySelector('.screenSize_icon');

    screen_size.addEventListener('click', this.changeScreenSize.bind(this));

    document.body.onkeyup = function (e) {
      if (e.keyCode == 32) {
        this.togglePlay();
      }
    }

    this.togglePlay();
  }

  changeScreenSize() {
    if (this.player.mozRequestFullScreen) {
      this.player.mozRequestFullScreen();
      //change icon
      this.screenSize_icon.className = "fa fa-compress";
      /*control panel once fullscreen*/
      this.video.addEventListener('mouseout', () => this.controls.style.transform = 'translateY(100%) translateX(-5px)');
      this.video.addEventListener('mouseover', () => this.controls.style.transform = 'translateY(0)');
      this.controls.addEventListener('mouseover', () => this.controls.style.transform = 'translateY(0)');
      this.screen_size.addEventListener('click', () => {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
          this.screenSize_icon.className = "fa fa-expand";
        }
      });
    } else if (this.player.webkitRequestFullScreen) {
      this.player.webkitRequestFullScreen();
      this.screenSize_icon.className = "fa fa-compress";
      this.video.addEventListener('mouseout', () => this.controls.style.transform = 'translateY(100%) translateX(-5px)');
      this.video.addEventListener('mouseover', () => this.controls.style.transform = 'translateY(0)');
      this.controls.addEventListener('mouseover', () => this.controls.style.transform = 'translateY(0)');
      this.screen_size.addEventListener('click', () => {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
          screenSize_icon.className = "fa fa-expand";
        }
      });
    }
  }

  // toggle between play and pause
  togglePlay() {
    if (this.video.paused) {
      this.video.play();
      this.playLeftBtn.classList.replace('fa-play', 'fa-pause');
      this.playLeftBtn.setAttribute('title', 'Pause');
      this.playLeftBtn.innerHTML = 'Pause';

      this.playRightBtn.classList.replace('fa-play', 'fa-pause');
      this.playRightBtn.setAttribute('title', 'Pause');
      this.playRightBtn.innerHTML = 'Pause';

    } else {
      this.playLeftBtn.classList.replace('fa-pause', 'fa-play');
      this.playLeftBtn.setAttribute('title', 'Play');
      this.playLeftBtn.innerHTML = 'Play';

      this.playRightBtn.classList.replace('fa-pause', 'fa-play');
      this.playRightBtn.setAttribute('title', 'Play');
      this.playRightBtn.innerHTML = 'Play';
      this.video.pause();
    }
  }

  // Stop video
  stopVideo() {
    this.video.currentTime = 0;
    this.video.pause();
  }

  // not sure, is this for FF and REW?
  skip(customButton, customVideo) {
    customVideo.pause();
    customVideo.currentTime += +(customButton.dataset.skip);
    customVideo.play();
  }

  // volume functions
  handleRangeUpdate() {
    this.video[this.name] = this.value;
    (this.video['volume'] === 0 ? this.speakerIcon.className = "fa fa-volume-off" :
      this.speakerIcon.className = "fa fa-volume-up")
  }



  mute() {
    if (!this.muted) {
      this.video['volume'] = 0;
      this.volInput.value = 0;
      this.speakerIcon.className = "fa fa-volume-off"
      this.muted = true;
    } else {
      this.video['volume'] = 1;
      this.volInput.value = 1;
      this.muted = false;
      this.speakerIcon.className = "fa fa-volume-up"
    }
  }

  // update progress bar as the video plays
  updateProgress() {
    this.progressBar.style.width = `${(this.video.currentTime / this.video.duration) * 100}%`;
    this.currentTime.textContent = `${this.displayTime(this.video.currentTime)} /`;
    this.duration.textContent = `${this.displayTime(this.video.duration)}`;
  }

  endedVideo() {
    this.playLeftBtn.classList.replace('fa-pause', 'fa-play');
    this.playLeftBtn.setAttribute('title', 'Play');
    this.playLeftBtn.innerHTML = 'Play';

    this.playRightBtn.classList.replace('fa-pause', 'fa-play');
    this.playRightBtn.setAttribute('title', 'Play');
    this.playRightBtn.innerHTML = 'Play';
    this.video.pause();
  }

  // Calculate display time format
  displayTime(time) {
    const minutes = Math.floor(time / 60);
    let seconds = Math.floor(time % 60);
    seconds = seconds > 9 ? seconds : `0${seconds}`;
    return `${minutes}:${seconds}`;
  }

  // Click to seek within the video
  setProgress(e) {
    const newTime = e.offsetX / this.progressRange.offsetWidth;
    this.progressBar.style.width = `${newTime * 100}%`;
    this.video.currentTime = newTime * this.video.duration;
  }

  scrub(event) {
    const scrubTime = (event.offsetX / this.progressRange.offsetWidth) * this.video.duration;
    this.video.currentTime = scrubTime;
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('div.libertine-player, video, model-viewer, iframe')).focus();
      this.setupCustomPlayer();

    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
    if (this.sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (!this.currentPageElement || !this.pageTotal) return;

    this.currentPageElement.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;

    if (this.enableSliderLooping) return;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderLastItem.clientWidth : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);


class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true, true);
      this.setUnavailable();
    } else {
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;
    modalContent.prepend(newMediaModal);
    parent.prepend(newMedia);
    this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
    if (this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }
    window.setTimeout(() => {
      parent.scrollLeft = 0;
      parent.querySelector('li.product__media-item').scrollIntoView({ behavior: 'smooth' });
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    let sectionId = this.dataset.section;
    if (this.dataset.custom) {
      sectionId = this.dataset.custom;
    }
    const productForms = document.querySelectorAll(`#product-form-${sectionId}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;
    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;
    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        let sectionId = this.dataset.section;
        if (this.dataset.custom) {
          sectionId = this.dataset.custom;
        }

        const id = `price-${sectionId}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${sectionId}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut, true, true);

        const outOfStock = document.getElementById(`out-of-stock-${sectionId}`);
        const outOfStockBottom = document.getElementById(`out-of-stock-bottom-${sectionId}`);
        const preorderEls = document.querySelectorAll('.static-estimated-shipping, .estimated-shipment');


        if (outOfStock) {
          outOfStock.querySelector('input[name="variant_id"]').value = this.currentVariant.id;
          outOfStock.querySelector('input[name="vtitle"]').value = this.currentVariant.title;
          outOfStock.querySelector('input[name="price"]').value = this.currentVariant.price;

          if (this.currentVariant.available) {
            outOfStock.classList.add('hidden');
            outOfStock.closest('.product-form').classList.remove('out-of-stock-enabled');
          } else {
            outOfStock.classList.remove('hidden');
            outOfStock.closest('.product-form').classList.add('out-of-stock-enabled');
          }
        }

        if (outOfStockBottom) {
          outOfStockBottom.querySelector('input[name="variant_id"]').value = this.currentVariant.id;
          outOfStockBottom.querySelector('input[name="vtitle"]').value = this.currentVariant.title;
          outOfStockBottom.querySelector('input[name="price"]').value = this.currentVariant.price;

          if (this.currentVariant.available) {
            outOfStockBottom.classList.add('hidden');
            outOfStockBottom.closest('.product-form').classList.remove('out-of-stock-enabled');
          } else {
            outOfStockBottom.classList.remove('hidden');
            outOfStockBottom.closest('.product-form').classList.add('out-of-stock-enabled');
          }
        }

        if (preorderEls.length > 0) {
          preorderEls.forEach((el) => {
            if (!this.currentVariant.available && (outOfStockBottom || outOfStock)) {
              el.classList.add('hidden');
            }else{
              el.classList.remove('hidden');
            }
          });
        }

        if (window.triggerSwymVariantEvent) {
          this.updateSwymVariant();
        }
      });
  }

  updateSwymVariant() {
    const _this = this;
    try {
      const wishlistBtns = document.getElementsByClassName("swym-add-to-wishlist-view-product");
      for (const btn of wishlistBtns) {
        btn.setAttribute('data-variant-id', _this.currentVariant.id);
      }
      window.SwymProductInfo.currentVariant = _this.currentVariant.id;
      window.triggerSwymVariantEvent(_this.currentVariant.id);
      window._swat.initializeActionButtons(".product-form__buttons--wishlist");
      window._swat.initializeActionButtons(".product-form__buttons--wishlist.mobile");
    } catch (error) {
      console.warn("Swym selectCallback", error);
    }
  }

  toggleAddButton(disable = true, text, modifyClass = true, hideClass = false) {
    let sectionId = this.dataset.section;
    if (this.dataset.custom) {
      sectionId = this.dataset.custom;
    }
    const productForm = document.getElementById(`product-form-${sectionId}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;
    if (hideClass) {
      addButton.classList.add('hidden');
    } else {
      addButton.classList.remove('hidden');
    }
    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      const isPreOrderTemplate = document.querySelector('input[name="properties[_TemplateSuffix]"][value*="pre-order"]');
      const preorderEls = document.querySelectorAll('.static-estimated-shipping, .estimated-shipment');
      if (preorderEls.length > 0 || isPreOrderTemplate) {
        addButtonText.textContent = window.variantStrings?.preOrder || 'Pre-order';
      } else {
        addButtonText.textContent = window.variantStrings.addToCart;
      }
    }
  }

  setUnavailable() {
    let sectionId = this.dataset.section;
    if (this.dataset.custom) {
      sectionId = this.dataset.custom;
    }
    const button = document.getElementById(`product-form-${sectionId}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${sectionId}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  connectedCallback() {
    this.updateOptions();
  }

  onVariantChange() {
    super.onVariantChange();
    this.dispatchEvent(new CustomEvent('variant:change', {
      bubbles: true,
      detail: { variant: this.currentVariant }
    }));
  }

  toggleAddButton(disable = true, text, modifyClass = true, hideClass = false) {

    let sectionId = this.dataset.section;
    if (this.dataset.custom) {
      sectionId = this.dataset.custom;
    }
    const productForm = document.getElementById(`product-form-${sectionId}`);

    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    addButton.classList.remove('hidden');

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      addButton.classList.add('disabled');
      if (hideClass) {
        addButton.classList.add('hidden');
      }
      if (text) addButtonText.textContent = text;

      if(document.querySelector('buy-now-button')){
        document.querySelector('buy-now-button').setAttribute('disabled', 'disabled');
        document.querySelector('buy-now-button').classList.add('hidden');
      }
    } else {
      addButton.removeAttribute('disabled');
      addButton.classList.remove('disabled');
      if (hideClass) {
        addButton.classList.remove('hidden');
      }

      if (document.querySelector('buy-now-button')) {
        document.querySelector('buy-now-button').removeAttribute('disabled');
        document.querySelector('buy-now-button').classList.remove('hidden');
      }

      const isPreOrderTemplate = document.querySelector('input[name="properties[_TemplateSuffix]"][value*="pre-order"]');
      const preorderEls = document.querySelectorAll('.static-estimated-shipping, .estimated-shipment');
      if (preorderEls.length > 0 || isPreOrderTemplate) {
        addButtonText.textContent = window.variantStrings?.preOrder || 'Pre-order';
      } else {
        addButtonText.textContent = window.variantStrings.addToCart;
      }
    }
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    fieldsets.map((fieldset) => {
      Array.from(fieldset.querySelectorAll('input')).map((input) => {
        if (input.checked) {
          const labelSpan = input.closest('fieldset').querySelector('.form__label span');
          if (labelSpan) labelSpan.innerHTML = input.name + ' ' + input.value;
        }
      });
    });

    if (!modifyClass) return;
  }

  // Overwrite updateOptions method to check for unavailable variants
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
    const possibleVariants = this.getVariantData().filter(variant => variant.option1 === this.options[0])
    for (let index = 0; index < possibleVariants.length; index++) {
      const variant = possibleVariants[index]
      const inputs = document.querySelectorAll(`[value="${variant.option2}"]`);
      for (let i = 0; i < inputs.length; i++) {

        if (!variant.available) {
          inputs[i].classList.add('unavailable')
          inputs[i].classList.add('p-sold-out');
          inputs[i].nextElementSibling.classList.add('p-sold-out');
        } else {
          inputs[i].classList.remove('unavailable')
          inputs[i].classList.remove('p-sold-out');
          inputs[i].nextElementSibling.classList.remove('p-sold-out');
        }

      }
    }
  }
}

customElements.define('variant-radios', VariantRadios);

/**
*  Lazy load images
*  This feature works only on collection_pages
*/
(function () {
  if (window.theme.lazy_load === true ) {
    let docImages = document.querySelectorAll('img.lazy-load');
    docImages.forEach(image => image.classList.add('lazy-loading'));
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(() => {
        docImages.forEach(image => {
          image.classList.add('lazy-loaded');
          image.classList.remove('lazy-load', 'lazy-loading');
        });
      }, 1000);
    });
  }
})();

/**
*  JS animations + CSS
*/
class JSAnimate {
  constructor(elements) {
    elements.forEach(element => this.initObserver(element));
  }

  initObserver(animateElement) {
    this.createObserver(animateElement);
  }

  observerCallback(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    setTimeout(() => {
      this.classList.contains('js-animation-container')
        ? this.classList.add('js-animate')
        : this.closest('.js-animation-container').classList.add('js-animate');
    }, 350);
  }

  createObserver(container) {
    let _this = this;
    let target = container.classList.contains('js-animation-target') ? container : container.querySelector('.js-animation-target');

    return new IntersectionObserver(_this.observerCallback.bind(target), { rootMargin: '20px 0px' }).observe(target);
  }
}

/**
*  Site sounds - enable/disable script
*/
const SiteSoundsHandler = function () {
  SiteSoundsHandler.prototype.muteSounds();
}

SiteSoundsHandler.prototype = {
  muteSounds: function (action = 'mute') {
    let HTMLVideos = [];
    let YTVideos = [];
    let vimeoVideos = [];
    let HTMLAudios = document.querySelectorAll('audio');

    let videos = document.querySelectorAll('video');
    let frames = document.querySelectorAll('iframe');

    videos.length > 0 && videos.forEach(video => {
      if (!video.hasAttribute('data-carousel-slide-video')) HTMLVideos.push(video);
    });
    frames.length > 0 && frames.forEach(frame => {
      frame.src.includes('youtube') && !frame.hasAttribute('data-carousel-slide-video')
        ? YTVideos.push(frame)
        : frame.src.includes('vimeo') && !frame.hasAttribute('data-carousel-slide-video')
          ? vimeoVideos.push(frame)
          : null;
    });

    if (HTMLVideos.length > 0) SiteSoundsHandler.prototype.muteHTMLvideos(HTMLVideos, action);
    if (YTVideos.length > 0) SiteSoundsHandler.prototype.muteYTvideos(YTVideos, action);
    if (vimeoVideos.length > 0) SiteSoundsHandler.prototype.muteVMvideos(vimeoVideos, action);
    SiteSoundsHandler.prototype.muteAudios(HTMLAudios, action);
  },

  muteHTMLvideos: function (videos, action) {
    videos.forEach(video => {
      if (action === 'mute') {
        video.muted = true;
      } else if (action === 'unMute') {
        video.muted = false;
      }
      video.onplay = (event) => {
        let target = event.target;
        if (!target.muted && action === 'mute') {
          target.pause();
          target.muted = true;
          target.play();
        } else if (target.muted && action === 'unMute') {
          target.pause();
          target.muted = false;
          target.play();
        }
      }
    });
  },

  muteYTvideos: function (videos, action) {
    videos.forEach(video => {
      if (!video.prototype.player) {
        video.prototype.player = new YT.Player(videoFrame, {
          events: {
            'onReady': function () {
              video.prototype.player.mute();
            }
          }
        });
      }
      if (!video.prototype.player.isMuted() && action === 'mute') {
        video.prototype.player.mute();
      } else if (video.prototype.player.isMuted() && action === 'unMute') {
        video.prototype.player.unMute();
      }
    });
  },

  muteVMvideos: function (videos, action) {
    videos.forEach(video => {
      if (!video.prototype.player) video.prototype.player = new Vimeo.Player(videoFrame);
      video.prototype.player.getVolume().then(resp => {
        if (resp === 1 && action === 'mute') {
          video.prototype.player.setVolume(0);
        } else if (resp === 0 && action === 'unMute') {
          video.prototype.player.setVolume(1);
        }
      });
    });
  },

  muteAudios: function (audios, action) {
    audios.length > 0 && audios.forEach(audio => {
      audio.muted = true;
      audio.onplay = (event) => {
        let target = event.target;
        if (!target.muted && action === 'mute') {
          target.pause();
          target.muted = true;
          target.play();
        } else if (target.muted && action === 'unMute') {
          target.pause();
          target.muted = false;
          target.play();
        }
      }
    });
  },

  unMuteSounds: function () {
    SiteSoundsHandler.prototype.muteSounds('unMute');
  }

}

/**
*  Cookies handler
*/

Shopify.storageHandler = function () { }
Shopify.storageHandler.prototype = {
  setContent: function (c_name = null, c_value = null) {
    if (!c_name && !c_value) return;
    localStorage.setItem(c_name, c_value);
  },

  getContent: function (c_name = null) {
    if (!c_name) return;
    return localStorage.getItem(c_name);
  }
}

/**
* Load secondary media (image, gif) on hover
* HOW TO:
*  - Listen parent container hover event
*  - when hovered, will search for secondary media and apply the data-src and data-srcset (if exist) to the image
*  - after image loaded, will remove css filters
*/
class SecondaryMedia {
  constructor() {
    this.media = document.querySelectorAll('.js-media-hover-load');
    if (this.media.length > 0) this.media.forEach((media) => this.Init(media));
  }

  Init(target) {
    target.addEventListener('mouseover', this.onHoverCallback, false);
  }

  onHoverCallback(event) {
    const target = this.querySelector('.media-hover');

    target.classList.add('hover-loading');
    target.src = target.dataset.src;
    target.srcset = target.dataset.srcset || "";
    target.onload = () => {
      target.classList.remove('hover-loading');
      target.classList.add('hover-loaded');

      this.removeEventListener('mouseover', this.onHoverCallback, false);
    }
  }
}

document.addEventListener('readystatechange', function () { // Start script on readyState 'interactive' or 'complete'
  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    new SecondaryMedia();
  }
});

document.addEventListener('DOMContentLoaded', () => {
  /**
   *  Lazy page load, make a transition on page load
   */
  let transitionWrapper = document.querySelector('.js-transition-wrapper');
  transitionWrapper && transitionWrapper.classList.add('loaded');

  /**
   *  Site sounds - enable/disable
   */
  if (window.theme.isSoundEnabled) SiteSoundsHandler();
});
